module.exports = __webpack_public_path__ + "img/process_icon.46749b0a.png";